import * as React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { CookiesProvider } from 'react-cookie';
const rootElement = document.getElementById('root');
ReactDOM.render(React.createElement(CookiesProvider, null,
    React.createElement(App, null)), rootElement);
